/**
 * Модификатор, устанавливающий минимальную ширину попапа относительно якоря.
 */
export var applyMinWidth = {
    name: 'applyMinWidth',
    enabled: true,
    fn: applyMinWidthFn,
    effect: applyMinWidthEffect,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
};
function applyMinWidthFn(_a) {
    var state = _a.state;
    state.styles.popper.minWidth = state.rects.reference.width + "px";
}
function applyMinWidthEffect(_a) {
    var state = _a.state;
    if (state.elements.reference instanceof HTMLElement) {
        state.elements.popper.style.minWidth = state.elements.reference.offsetWidth + "px";
    }
}
